import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from '../svgs/E3_Pause.svg'

const E3Pause: React.VFC<SvgIconProps> = props => <SvgIcon viewBox={'0 0 30 31'} component={Icon} {...props} fill="currentColor" />
export default E3Pause
